import React from 'react';
import styles from '../../Balance.module.scss';
import { getItemName } from '../../Utils/dashboardUtils';
//assets
//import SVG from 'react-inlinesvg';

//Tr
import { useTranslation } from 'react-i18next';
import { Balance } from '../../../../sagas/dashboard/types';

interface BalanceTableItemProps {
  transaction: Balance;
}

export const BalanceTableItem: React.FC<BalanceTableItemProps> = ({
  transaction,
}) => {
  const { t } = useTranslation();

  //   const [isOpen, setIsOpen] = useState(false);

  return (
    <div key={transaction.ID} className={styles.tableItemMobile}>
      <div className={styles.body}>
        <div>
          <label>
            {getItemName(transaction.type, transaction.metadata, t)}
          </label>
          <label>{transaction.netIncome.toString()}</label>
        </div>
      </div>
    </div>
  );
};
